// Import specific icons
import {
  faUserSecret,
  faFishFins,
  faWheatAwn,
  faEgg,
  faGlassWaterDroplet,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faCopy,
  faUtensils,
  faCalendarDay,
  faTimes,
  faExclamationTriangle,
  faInfoCircle,
  faLightbulb,
  faEllipsisVertical
} from '@fortawesome/free-solid-svg-icons'

import {
  faTrash,
  faTrashCanXmark,
  faSpinnerThird,
  faWandMagic,
  faWandMagicSparkles,
  faSalad
} from '@fortawesome/pro-duotone-svg-icons'

// Export as object values (array) for library.add()
export default [
  faUserSecret,
  faFishFins,
  faWheatAwn,
  faEgg,
  faGlassWaterDroplet,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faCopy,
  faUtensils,
  faCalendarDay,
  faTimes,
  faExclamationTriangle,
  faInfoCircle,
  faLightbulb,
  faEllipsisVertical,
  faTrash,
  faTrashCanXmark,
  faSpinnerThird,
  faWandMagic,
  faWandMagicSparkles,
  faSalad
]
